/**
 * 会话页 输入框
 */

import './index.scss';

import { useMemo, useState, forwardRef, useImperativeHandle, } from 'react';

import { MESSAGE_MAX_LENGTH } from '@/shared/chat';
import EE from '@/common/event';

import { Divider } from 'antd';
import Microphone from '@/components/microphone';
import ChatEditor from '@/components/chat/ChatEditor';
import SendButton from '@/components/chat/SendButton';
import StopButton from '@/components/chat/StopButton';
import { observer } from 'mobx-react-lite';
import chatStoreManager from '@/store/chat/manager';
import navbarStore from '@/store/navbar';
import appLogger from '@public/log/monitor';
import inputTypeStore from '@/components/input-file/input-type';
import { HelpOther } from '@/common/helper';
import UploadButton from '@/components/chat/UploadButton';
import Conf from '@/common/conf';
import globalStore from '@/store/global';
import { useEffect } from 'react';
import { useRef } from 'react';
import client from '@/store/client';
import KnowledgeChoice from '@/components/knowledge-choice';
import ChatMultiFile from '@/components/chat/ChatMultiFile';
import fileStore from '@/store/chat/fileStore';
import KnowledgeModelSelect from '@/pages/chat-knowledge/components/knowledege-model-select';
import knowledgeModelSelectStore from '@/pages/chat-knowledge/components/knowledege-model-select/store';
import modelChoiceStore from '@/components/model-choice/store';
import ScreenShot from '@/components/chat/ScreenShot';
import FoldSwitch from '@/ui/fold-switch';
import { useMeasure } from 'react-use';
import Loader from '@/common/helper/loader';
import ServerChoice from '@/components/server-choice';
import useFilePaste from '@/components/chat/ChatInput/file-paste';
import Cascaders from '@/components/chat/ChatInput/Gaokaoxk/Cascaders'
import fieldCategoryStore from '@/components/field-category/store';
import { CloseOutlined } from '@ant-design/icons';
import GaokaoxkStore from '@/components/chat/ChatInput/Gaokaoxk/GaokaoxkStore'
import Tooltip from '@/ui/tooltip';

function getInputTextWidth(inputElement) {
  const tempElement = document.createElement('span');
  tempElement.style.visibility = 'hidden';
  tempElement.style.whiteSpace = 'pre';
  tempElement.style.font = window.getComputedStyle(inputElement).font;
  tempElement.textContent = inputElement.value;
  document.body.appendChild(tempElement);
  const width = tempElement.getBoundingClientRect().width;
  document.body.removeChild(tempElement);
  return width;
}

function ChatInput(props, ref) {
  const { className, canAborting, isAITyping, onSend, isKnowledgeChat, isPromptTyping } = props;
  const $refInput = useRef(null);
  const chatStore = chatStoreManager.current || {};
  const { isRecommendAgent } = chatStore;
  const currAsstId = isKnowledgeChat ? knowledgeModelSelectStore.curId : chatStore.currAsstId;
  const [value, setValue] = useState('');
  const [textareaWidth, setTextareaWidth] = useState(false);
  const [isTextareaRows, setIsTextareaRows] = useState(false);
  const [$refContainer, { width: widthContainer }] = useMeasure();
  const [serverList, setServerList] = useState([]);
  const isAgentFlow = chatStore.mcpStore.isAgentFlow;

  const isAllFieldsValid = () => {
    // 检查所有字段是否有值
    const allFieldsFilled = Object.entries(GaokaoxkStore.requiredFields).every(([key, value]) => {
      if (key === 'optional') {
        // 如果是 optional，检查长度是否等于 maxCount
        if (value.length !== GaokaoxkStore.requiredFields.maxCount) {
          return false;
        }
        return true;
      }
      if (Array.isArray(value)) {
        // 如果是数组，检查是否非空
        if (value.length === 0) {
          return false;
        }
        return true;
      }
      // 对于其他类型，检查是否非空
      if (value === '') {
        return false;
      }
      return true;
    });

    return allFieldsFilled;
  };


  const isGaokao = useMemo(() => {
    if (globalStore?.cloudConfig?.assistantGaokaoAgentList?.includes(chatStore.mcpStore.agentInfo?.id)) {
      // 智能体首页，根据云控来控制是否显示高考信息输入项
      return true;
    }
    return fieldCategoryStore.curCategoryIdx === 0;
  }
    , [fieldCategoryStore.curCategoryIdx, globalStore?.cloudConfig?.assistantGaokaoAgentList, chatStore.mcpStore.agentInfo]);
  const gaokao = !isAllFieldsValid()
  const disabled = useMemo(() => {
    return props.disabled || value.trim().length == 0;
  }, [props.disabled, value]);
  const btnDisabled = isGaokao ? gaokao : (
    disabled
    && !(
      chatStore.mcpStore.agentInfo
      && chatStore.mcpStore.agentInfo.doc_def_prompt
      && inputTypeStore.tempFile
    )
  )
    || inputTypeStore.sendDisabled;

  const maxLength = useMemo(() => {
    if (globalStore.globalConfig.donotLimitInput) {
      return;
    }

    let maxLength = navbarStore.chatModels[currAsstId]?.input_length;
    maxLength = maxLength > 0 ? maxLength : MESSAGE_MAX_LENGTH;
    return maxLength;
  }, [currAsstId]);

  /** 会话中发送消息的方法，prompt type 可选 */
  const handleSend = (prompt, type) => {
    // 如果有使用 prompt 则不走下面条件
    if (!prompt) {
      if (!isPromptTyping && btnDisabled) {
        return;
      }
    }
    if (isAITyping) {
      return;
    }

    chatStoreManager.setNewChatLogData({
      key: appLogger.getRouterName(),
      input_type: "text_inout", // 文字输入
    });

    const params = {
      value: value.trim() || chatStore.mcpStore.agentInfo?.doc_def_prompt || (isGaokao && GaokaoxkStore.prompt) || "",
      ...inputTypeStore.getSendParams(),
      // 高考填志愿
      kwargs: {
        gaokao_intention: GaokaoxkStore.getFields(),
      },
    }
    // 如果通过上传文件后的 总结关键点、生成大纲等提示词发送
    if (prompt && type) {
      params.value = prompt
      params.fileType = type
    }

    onSend?.(params);

    setTimeout(() => {
      setIsTextareaRows(textareaWidth > 0 && getInputTextWidth($refInput?.current?.value) > textareaWidth - 8);
    }, 20);
  };

  useEffect(() => {
    const textarea = $refInput?.current?.value;
    if (textarea) {
      setTextareaWidth(textarea.clientWidth);
    }
  }, [$refInput]);

  const isShowSo = useMemo(() => {
    if (chatStore.mcpStore.isAgent) {
      return false;
    }

    return globalStore.getRobotOnlineSet(currAsstId);
  }, [currAsstId, navbarStore.chatModels, chatStore.mcpStore.isAgent]);
  const isShowDeep = useMemo(() => {
    if (isKnowledgeChat && knowledgeModelSelectStore.modelInfo) {
      return knowledgeModelSelectStore.modelInfo.deep
        && knowledgeModelSelectStore.modelInfo.deep == "r1"
        && globalStore.getRobotDeepSet(Conf.roleIds.knowledge)
    }
    return globalStore.getRobotDeepSet(currAsstId);
  }, [currAsstId])

  const { pasteFiles, setPasteFiles, handlePasteChange } = useFilePaste()
  useEffect(() => {
    if (!pasteFiles.length) return
    if (isShowSo && globalStore.is_so) {
      HelpOther.toast(`联网搜索不支持上传图片`, "info");
      setPasteFiles([]);
      return;
    }
    // console.info('>>> paste', pasteFiles)
    inputTypeStore.updateTempData('tempFile', pasteFiles)
    setPasteFiles([]);
  }, [pasteFiles, isShowSo, globalStore.is_so])

  useEffect(() => {
    globalStore.robotOnlineSo(currAsstId);
    globalStore.robotDynamicPageSo(currAsstId);

    if (currAsstId) {
      navbarStore.getSpecifyModel(currAsstId)
        .then(() => {
          globalStore.robotDeepSo(currAsstId);
        });
    }
  }, [currAsstId]);

  useEffect(() => {
    let list = [];
    if (chatStore.lastMessage?.cloud_mcp || chatStore.lastMessage?.mcp) {
      let mcpList = [];
      if (chatStore.lastMessage?.mcp?.length) {
        mcpList = chatStore.lastMessage?.mcp.map(item => item.server_name)
      }
      list = [].concat(chatStore.lastMessage?.cloud_mcp || []).concat(mcpList);
    }
    setServerList(list)
  }, [currAsstId]);

  // 更新输入框内文本
  const setQuery = (query) => {
    setValue(query);
  };
  useEffect(() => {
    EE.on('set_query', setQuery);
    return () => {
      EE.off('set_query', setQuery);
    };
  }, []);
  useImperativeHandle(ref, () => ({
    // 用于外部修改输入框的值（当前是替换)
    setValue(value) {
      setValue(value)
    },
  }))
  const handleSo = () => {
    globalStore.robotOnlineSo(currAsstId, !globalStore.is_so);

    if (globalStore.is_so) {
      inputTypeStore.reset();
    }
  }
  const handleDeep = () => {
    const roleId = isKnowledgeChat ? knowledgeModelSelectStore.modelInfo.id : currAsstId;

    globalStore.robotDeepSo(roleId, !globalStore.is_deep[roleId])
  }

  const handleDyPage = () => {
    globalStore.robotDynamicPageSo(modelChoiceStore.curId, !globalStore.is_dy_page)
    appLogger.log({
      key: appLogger.getRouterName(),
      action: 'click',
      arrt: 'so_page',
    });
  }

  const clearStatus = () => {
    setValue('');
  }

  useEffect(() => {
    EE.on('send_message_sucess', clearStatus);
    return () => {
      EE.off('send_message_sucess', clearStatus);
    };
  }, []);
  const enableServerChoice = useMemo(() => {
    try {
      const list = globalStore.cloudConfig?.assistantLlmMcp?.roleids?.split(',');
      return list.includes(currAsstId);
    } catch (e) { }
    return false;
  }, [currAsstId])

  const showUpload = (
    (
      currAsstId == Conf.roleIds.assistant
      || inputTypeStore.supportUploadFile
    )
    && (
      (
        currAsstId
        && navbarStore.chatModels[currAsstId]?.conversation_type != 1
        && !navbarStore.chatModels[currAsstId]?.localModel
      )
      || (
        (
          // 仅简版智能体支持
          chatStore.mcpStore.isSimpleAgent
          // 智能体都支持
          || globalStore.globalConfig.supportUploadFileWithAllAgent
        )
      )
    )
    && !isKnowledgeChat
    && (!isAgentFlow || globalStore.globalConfig.supportKnowledgeWithFlow)
  );


  return (
    <div
      className={[
        'chat__input',
        'w-full relative',
        "rounded-12px",
        'border-1px border-black border-opacity-16 bg-white',
        isPromptTyping ? "rounded-tl-none rounded-tr-none" : "",
        className]}
      style={{
        boxShadow: '0px 2px 6px 0px rgba(0, 0, 0, 0.10)',
        boxSizing: 'border-box'
      }}
      ref={$refContainer}
    >
      <div className={`w-full p-12px bg-input-bg-normal overflow-hidden rounded-24px py-12px`}>
        {
          inputTypeStore.tempFile && (inputTypeStore.supportUploadFile)
            ? <ChatMultiFile handleSend={handleSend} supportKnowledge={false} scene="chat" />
            : null
        }

        <div className={
          [
            'chat-input-warp w-full flex gap-14px',
            "flex-col",
            { 'textarea-rows': isTextareaRows }
          ]}>
          <div className="chat-input-textarea pl-4px w-full">
            {isGaokao ? <Cascaders /> :
              <ChatEditor
                ref={$refInput}
                roleId={currAsstId}
                isAgent={chatStore.mcpStore.isAgent}
                className="!p-0px nw-scrollbar !min-h-22px !leading-22px"
                maxLength={maxLength}
                autoSize={{ minRows: 1, maxRows: 10 }}
                value={value}
                placeholder={isKnowledgeChat ? "基于知识库提问" : ""}
                onChange={value => {
                  setValue(value);
                  setTimeout(() => {
                    setIsTextareaRows(textareaWidth > 0 && getInputTextWidth($refInput?.current?.value) > textareaWidth - 8);
                  }, 20);
                }}
                onPressEnter={handleSend}
                handlePaste={handlePasteChange}
              />
            }
          </div>
          <div className={`flex items-end justify-between w-full`}>
            <div className='flex items-end justify-start gap-8px'>
              {
                isKnowledgeChat
                  && (client.isLLQ || globalStore.globalConfig.supportSelectModelInWebKnowledge)
                  ? <KnowledgeModelSelect />
                  : null
              }
              {
                Loader.isDynamicPageRole(currAsstId) && !isPromptTyping && currAsstId
                  ? (
                    <FoldSwitch
                      onClick={handleDyPage}
                      text="AI动态网页"
                      iconName="dy_page"
                      small={widthContainer < Loader.size.chatSmall}
                      circle
                      checked={globalStore.is_dy_page}
                    />
                  )
                  : null
              }
              {
                isShowDeep && !isPromptTyping && currAsstId
                  ? (
                    <FoldSwitch
                      onClick={handleDeep}
                      text="深度"
                      iconName="deepseek"
                      small={widthContainer < Loader.size.chatSmall}
                      circle
                      checked={globalStore.is_deep[
                        isKnowledgeChat
                          ? knowledgeModelSelectStore.modelInfo?.id
                          : currAsstId
                      ]}
                    />
                  )
                  : null
              }
              {
                // 以下是非知识库逻辑
                isShowSo && !isPromptTyping && currAsstId && navbarStore.chatModels[currAsstId]?.conversation_type != 1
                  ? (
                    <FoldSwitch
                      onClick={handleSo}
                      text="联网"
                      iconName="net"
                      small={widthContainer < Loader.size.chatSmall}
                      circle
                      checked={globalStore.is_so}
                    />
                  )
                  : null
              }
              {
                isKnowledgeChat
                  || (isRecommendAgent)
                  || chatStore.mcpStore.isMcpAgent
                  || globalStore.globalConfig.supportModelWithMultiKnowledge
                  ? null
                  : <KnowledgeChoice />
              }
              {
                client.supportMcpAgent && enableServerChoice && !chatStore.mcpStore.isAgent ? <ServerChoice serverList={serverList} /> : null
              }
            </div>
            <div className="flex items-center chat-input-tools">
              <div className="flex items-center">
                {
                  showUpload
                    && (
                      chatStore.mcpStore.isMcpAgent
                      || (globalStore.globalConfig.supportModelWithMultiKnowledge)
                    )
                    && globalStore.globalConfig.supportNewFileInput && !isGaokao
                    && !(isAgentFlow && !globalStore.globalConfig.supportKnowledgeWithFlow)
                    ? (
                      <>
                        <div className="min-w-36px">
                          <UploadButton isShowSo={isShowSo} onlyKnowledge supportKnowledge={true} chatStore={chatStore} simple className="mr-8px" scene="chat" />
                        </div>
                      </>
                    )
                    : null
                }
                {
                  // 仅客户端可截图
                  globalStore.cloudConfig.webConfig?.support_screen_shot == 1
                  && client.supportScreenShot
                  && globalStore.globalConfig.supportNewFileInput && !isGaokao
                  && !(isAgentFlow && !globalStore.globalConfig.supportKnowledgeWithFlow)
                    ? (
                      <ScreenShot className="mr-8px"
                        isShowSo={isShowSo}
                      />
                    )
                    : null
                }
                {
                  showUpload && !isGaokao
                    ? (
                      chatStore.mcpStore.isAgent && globalStore.globalConfig.supportNewFileInput
                        ? (
                          <>
                            <div className="min-w-36px">
                              <UploadButton agentInfo={chatStore.mcpStore.agentInfo} isShowSo={isShowSo} multiImage supportKnowledge={chatStore.mcpStore.isAgent} chatStore={chatStore} simple className="mr-8px" scene="chat" />
                            </div>
                            <div className="min-w-36px">
                              <UploadButton agentInfo={chatStore.mcpStore.agentInfo} isShowSo={isShowSo} multiFile supportKnowledge={chatStore.mcpStore.isAgent} notMedias={!chatStore.mcpStore.isAgent || !chatStore.mcpStore.isMcpAgent} chatStore={chatStore} simple className="mr-8px" scene="chat" />
                            </div>
                          </>
                        )
                        : (
                          <div className="min-w-36px">
                            <UploadButton isShowSo={isShowSo} supportKnowledge={chatStore.mcpStore.isMcpAgent} chatStore={chatStore} simple className="mr-8px" scene="chat" />
                          </div>
                        )
                    )
                    : null
                }
                {!isGaokao ? <Microphone
                  isKnowledgeChat={isKnowledgeChat}
                  onChange={value => {
                    setValue(v => v + value);
                    EE.emit('chat_input_focus');
                  }}
                /> : null}
              </div>

              {!isGaokao ? <Divider className={`!mx-16px ${!client.supportMic ? 'hidden-in-client' : ''}`} type="vertical" /> : null}
              {
                !isGaokao ? '' :
                  <div
                    className={`absolute top-[10px]  cursor-pointer w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-all`}
                    onClick={() => {
                      fieldCategoryStore.reset();
                      GaokaoxkStore.clearRequiredFields();
                      GaokaoxkStore.clearOptionalFields();
                    }}
                  >
                    <CloseOutlined className="text-gray-600 " />
                  </div>
              }

              {canAborting && isAITyping ?
                <StopButton
                  className="flex-shrink-0 size-32px flex justify-center items-center"
                  onClick={() => {
                    fileStore.stopAllRecursive()
                    chatStore.abort();
                  }}
                /> :
                <Tooltip
                  title={(isPromptTyping ? false : btnDisabled) && isGaokao ? '请填完必填项再提交哦~' : ""}
                  overlayStyle={{ zIndex: 9999 }} // 确保层级最高
                >
                  <div>
                    <SendButton
                      disabled={isPromptTyping ? false : btnDisabled}
                      onClick={handleSend}
                      className="flex-shrink-0 size-32px flex justify-center items-center"
                    />
                  </div>
                </Tooltip>

              }

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(forwardRef(ChatInput));
